const periodLabels: Record<string, { one: string; other: string }> = {
  d: { one: 'Day', other: 'Days' },
  m: { one: 'Month', other: 'Months' },
  y: { one: 'Year', other: 'Years' },
  v: { one: 'Value', other: 'Values' }
};

const pluralRules = new Intl.PluralRules('en-US');

export const getPeriodLabel = (period: string, periodNumber: string | number) => {
  const label = periodLabels[period];
  if (!label) return period;

  const numericValue =
    typeof periodNumber === 'number' ? periodNumber : Number.parseInt(periodNumber, 10);
  const pluralCategory = Number.isFinite(numericValue)
    ? pluralRules.select(Math.abs(numericValue))
    : 'other';

  return pluralCategory === 'one' ? label.one : label.other;
};
